import { Injectable } from '@angular/core';
import { isArray, isObject, mergeDeep } from '../../functions/util-functions';
import { Observable, BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class SiteSettingsService {
    private _settings: Map<string, BehaviorSubject<any>> = new Map();

    private _$changePipe: Subject<{ site: string; value: any }> = new Subject();

    private _sites: Array<string> = [];

    public get doormatContactColumn(): any {
        return this.getValue('doormatContactColumn');
    }

    public get headerLinks(): any {
        return this.getValue('headerLinks');
    }

    constructor() {}

    public get sites(): Array<string> {
        return [...this._sites];
    }

    public changes$(): Observable<{ site: string; value: any }> {
        return this._$changePipe.asObservable();
    }

    public getValue$<T = any>(key: string): Observable<T> {
        const _key = key.toLowerCase();
        if (!this._settings.has(_key)) {
            this._settings.set(_key, new BehaviorSubject(null));
        }
        return this._settings.get(_key).asObservable();
    }

    public getValue<T = any>(key: string): T {
        const _key = key.toLowerCase();
        if (this._settings.has(_key)) {
            return this._settings.get(_key).getValue();
        }
        throw new Error(`[SiteSettingsService] getValue: the key '${key}' is not defined.`);
    }

    public setSettings(settings: Array<any>) {
        settings.map((item) => {
            const _key = item.key.toLowerCase();
            const _preValue = isArray(item.value) ? [] : isObject(item.value) ? {} : '';

            let _settings = this._settings.has(_key) ? this._settings.get(_key).getValue() : _preValue;
            _settings = mergeDeep(_settings, item.value);

            if (this._settings.has(_key)) {
                this._settings.get(_key).next(_settings);
            } else {
                this._sites.push(_key);
                this._settings.set(_key, new BehaviorSubject(_settings));
            }
            this._$changePipe.next({ site: _key, value: _settings });
        });
    }
}
